import { Box, useTheme } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { tokens } from "../../../../../../theme";

import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from "react-i18next";
import MAddOrderField from "../../../../../../components/global/Modals/MAddOrderField";
import ButtonGroup from "../../../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../../../components/theme/buttons/Shbutton";
import ShDataGrid2 from "../../../../../../components/theme/datagrid2/ShDataGrid2";
import ShTextSkeleton from "../../../../../../components/theme/skeleton/ShTextSkeleton";
import SidepanelLoader from "../../../../../../components/theme/sidepanel2/SidepanelLoader";
import { selectUserPermission } from "../../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from "../../../../../../utils/permissions";
import { useSelector } from "react-redux";
import { generateColorFromTitle, generateIconColorFromTitle } from "../../../../../../components/theme/TabView3/IconColorGenerator";
import Text from "../../../../../../components/theme/text/Text";
import ProductExtraFieldsCard from "../../../../../../components/global/cards/settings/ProductExtraFieldsCard";
import { useGetOrderFieldsQuery } from "../../../../../../newapi/order/orderFieldSlice";
import { useAddInternalReasonsMutation, useGetInternalReasonsQuery } from "../../../../../../newapi/internalreason/internalReasonSlice";
import MDynamicValues from "../../../../../../components/global/Modals/MDynamicValues";
import { showToastMessage, showToastMessagePostRequest, showToastMessageRequestError } from "../../../../../../utils/toasts";

const SpOrderValueDetails = SidepanelLoader(() => import("../../../../../../components/global/Sidepanels/SpOrderValueDetails/SpOrderValueDetails"));

const GridActions = (props, i18n) => {
    const theme = useTheme();
    useEffect(() => {},[props.open]);

    const {t} = useTranslation();
    return (      
        <ButtonGroup version={2}>
            <Shbutton 
                onClick={() => props.handleOpen(true)}
                className={"group-btn"} 
                color={theme.palette.mode === "dark" ? "blue" : "primary"} 
                variant="contained" 
                endIcon={<AddIcon/>}>
                    {t("new_reason")}
            </Shbutton>
        </ButtonGroup>
    );
}

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
};

const Return = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [isExtended,setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();

    const [config, setConfig] = useState({types: ["process_return_reason", "create_return_reason"]});

    const [newReasonModalOpen, setNewReasonModalOpen] = useState(false);
    const newReasonModal = {
        open: newReasonModalOpen,
        setOpen: setNewReasonModalOpen
    }
    
    const [createNewReason,{isLoading: createLoading}] = useAddInternalReasonsMutation();
    const handleNewReasonConfirm = async(values) => {
        if (values.type.length === 0 || values.description.length === 0) {
            showToastMessage("error", t("fields_missing"));
            return;
        }

        try {
            if (createLoading) return;

            const data = await createNewReason({
                type: values.type,
                description: values.description
            }).unwrap();
            showToastMessagePostRequest(t, data);
        } catch (err) {
            showToastMessageRequestError(t("create_failed"), t, err);
        }
    }

    const [orderFieldId, setOrderFieldId] = useState();
    const orderFieldIdRef = useRef(orderFieldId);
    
    const getOrderFieldDetails = (params) => {
        if (!params) return;
    
        const newOrderFieldId = parseInt(params.row.id);
        // Only update state if the webshopCredentialsId has actually changed
        if (orderFieldIdRef.current !== newOrderFieldId) {
            if(!spLoading) {
                setSpLoading(true);
            }
            setOrderFieldId(newOrderFieldId);
            orderFieldIdRef.current = newOrderFieldId; // Update the ref to the new value
        }
        setIsExtended(true);
    };

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions:gridOptions,
            mobileActions:<GridActions handleOpen={() => setNewReasonModalOpen(true)}></GridActions>
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[setNewReasonModalOpen]);
    
    const columns = [
        {field: "description", headerName: t("description"),flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return <Text semibold>{params.row.description}</Text>
            }
        },
        {field: "type", headerName: t("type"),flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return params.row.type === "create_return_reason" ? t('create_return_reason') : t('process_return_reason');
            }
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <ProductExtraFieldsCard 
                        skeleton={params.row.skeleton ?? false}
                        onClick={() => getOrderFieldDetails(params)}
                        {...params.row}
                    />
                )
            }
        }
    ];

    return (
        <Box
            sx={{
                height:1,
                "@media screen and (max-width: 47.9375em)" : {
                    paddingTop:0,
                    paddingX:0,
                }
            }}
        >
            
            <ShDataGrid2 key={theme.palette.mode}
                content={useGetInternalReasonsQuery}
                config={config}
                gridActions={<GridActions handleOpen={() => setNewReasonModalOpen(true)}></GridActions>} 
                title={t("return_reasons")}
                gridOptions={gridOptions} 
                sortModel={{field: columns[0].field,type:"ASC"}}
                    
                columns={columns}
                onRowClick={getOrderFieldDetails}>
            </ShDataGrid2>

            <MDynamicValues
                open={newReasonModal.open}
                handleClose={() => newReasonModal.setOpen(false)}
                title={t("create_new_reason")}
                labelWidth={120}
                fields={[
                    { name: "type", label: t("type"), type: "list", options: [{id: "create_return_reason", name: t('create_return_reason')}, {id: "process_return_reason", name: t('process_return_reason')}] },
                    { name: "description", label: t("description"), type: "text", },
                ]}
                onConfirm={(values) => handleNewReasonConfirm(values)}
            />


            {spLoading && 
                <SpOrderValueDetails
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    orderFieldId={orderFieldId}
                    // data={credentialData}  
                /> 
            }
        </Box>
    )
};

export default Return;